var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-textarea", class: { "is-focus ": _vm.showFocusMode } },
    [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.current_value,
            expression: "current_value"
          }
        ],
        ref: "textarea",
        staticClass: "form-control",
        class: _vm.additionalClass,
        attrs: {
          rows: _vm.rows,
          name: _vm.name,
          placeholder: _vm.current_placeholder,
          disabled: _vm.disabled
        },
        domProps: { value: _vm.current_value },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.current_value = $event.target.value
            },
            _vm.onInput
          ],
          focus: _vm.onFocus,
          blur: _vm.onBlur
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "my-textarea-label",
          class: { "font-weight-bold ": _vm.showFocusMode },
          on: {
            click: function($event) {
              return _vm.$refs.textarea.focus()
            }
          }
        },
        [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }